module.exports = __webpack_public_path__ + "static/img/m4.1054972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m4.png
// module id = sUpy
// module chunks = 12